/* ==========================================================================
   Vortex Corner - theme.js (vanilla, sans dépendance)
   Panier Ajax · recherche prédictive · favoris · pop-up Club · carrousel · méga-menu
   galerie découverte · bandeau / infobulle 1re visite · fiches produit · collections
   Les animations sont portées par vx-motion.css / vx-motion.js (attributs data-vx-*).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__vxTheme) return; window.__vxTheme = true;

  var d = document, root = d.documentElement;
  var T = window.vxTheme || { routes: {}, strings: {} };
  var S = T.strings || {};
  var R = T.routes || {};
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ---------- Utilitaires ---------- */
  function qs(s, el) { return (el || d).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  function tpl(str, map) { str = String(str || ''); for (var k in map) str = str.split(k).join(map[k]); return str; }
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function pad2(n) { return n < 10 ? '0' + n : String(n); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function norm(t) {
    return String(t || '').toLowerCase().replace(/ø/g, 'o').replace(/æ/g, 'ae').replace(/œ/g, 'oe').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    cents = Math.round(Number(cents) || 0);
    function withDelims(n, prec, th, dec) {
      var num = (n / 100).toFixed(prec), parts = num.split('.');
      var ints = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      var out = ints + (parts[1] ? dec + parts[1] : '');
      return out.replace(new RegExp('\\' + dec + '00$'), '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Modales : pile, focus piégé, Échap (recherche › pop-up › panier) ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var stack = [];
  function lockScroll() { root.style.overflow = stack.length ? 'hidden' : ''; }
  function openModal(el, opts) {
    if (!el) return;
    opts = opts || {};
    var i = stack.findIndex(function (m) { return m.el === el; });
    if (i > -1) return;
    el.removeAttribute('data-vx-closing');
    el.hidden = false;
    stack.push({ el: el, opener: opts.opener || d.activeElement, onClose: opts.onClose, priority: opts.priority || 0 });
    lockScroll();
    var f = opts.focus ? qs(opts.focus, el) : null;
    setTimeout(function () { (f || qsa(FOCUSABLE, el).filter(visible)[0] || el).focus({ preventScroll: true }); }, 30);
  }
  function visible(n) { return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length); }
  function closeModal(el, done) {
    var i = stack.findIndex(function (m) { return m.el === el; });
    if (i < 0) { if (done) done(); return; }
    var m = stack.splice(i, 1)[0];
    lockScroll();
    var finish = function () { el.hidden = true; if (m.onClose) m.onClose(); if (done) done(); };
    if (window.vxClose && el.hasAttribute('data-vx-animated-close')) window.vxClose(el, finish); else finish();
    if (m.opener && m.opener.focus && d.contains(m.opener)) m.opener.focus({ preventScroll: true });
  }
  on(d, 'keydown', function (e) {
    if (!stack.length) return;
    if (e.key === 'Escape') {
      var top = stack.slice().sort(function (a, b) { return b.priority - a.priority; })[0];
      e.preventDefault(); closeModal(top.el); return;
    }
    if (e.key === 'Tab') {
      var cur = stack[stack.length - 1].el;
      var f = qsa(FOCUSABLE, cur).filter(visible);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!cur.contains(d.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Messages « posté » (formulaires client : #id de retour) ---------- */
  function postedFor(id) { return location.hash === '#' + id && /customer_posted=true|contact_posted=true/.test(location.search); }
  function initPosted() {
    qsa('[data-vx-posted-for]').forEach(function (el) {
      var id = el.getAttribute('data-vx-posted-for');
      if (el.hasAttribute('data-vx-never')) return;
      if (postedFor(id)) el.hidden = false;
    });
    // Erreurs d'un formulaire client : affichées sous le bon formulaire (#id de retour)
    qsa('[data-vx-error-for]').forEach(function (el) {
      var id = el.getAttribute('data-vx-error-for'), src = qs('[data-vx-form-errors-for="' + id + '"]');
      if (src && location.hash === '#' + id) { el.textContent = src.textContent.trim(); el.hidden = false; var f = d.getElementById(id); if (f) { f.hidden = false; f.classList.add('is-open'); } }
    });
    // Adresses : pays enregistré + provinces
    qsa('[data-vx-country]').forEach(function (sel) {
      var form = sel.form, prov = form && qs('[data-vx-province]', form), wrap = form && qs('[data-vx-province-wrap]', form);
      var def = sel.getAttribute('data-default');
      if (def) Array.prototype.forEach.call(sel.options, function (o) { if (o.value === def || o.textContent.trim() === def) sel.value = o.value; });
      function fill(first) {
        if (!prov) return;
        var opt = sel.options[sel.selectedIndex], list = [];
        try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) {}
        prov.innerHTML = '';
        list.forEach(function (p) { var o = d.createElement('option'); o.value = p[0]; o.textContent = p[1]; prov.appendChild(o); });
        if (first && prov.getAttribute('data-default')) prov.value = prov.getAttribute('data-default');
        if (wrap) wrap.hidden = !list.length;
      }
      on(sel, 'change', function () { fill(false); });
      fill(true);
    });
  }

  /* ---------- En-tête : méga-menu, menu mobile, recherche ---------- */
  function initHeader() {
    var wrap = qs('[data-vx-headwrap]');
    if (!wrap) return;
    var megas = qsa('[data-vx-mega]', wrap);
    var openers = qsa('[data-vx-mega-open]', wrap);
    var current = null, closeT;
    // Safari : on ne dépend pas de (hover: hover) ; seul un écran tactile pur (hover: none) est exclu.
    var noHover = window.matchMedia ? matchMedia('(hover: none)') : { matches: false };
    function desktop() { return !noHover.matches && window.innerWidth > 1240; }
    function show(key) {
      clearTimeout(closeT);
      if (!desktop()) return;
      megas.forEach(function (m) { var hit = m.getAttribute('data-vx-mega') === key; if (hit && m.hidden) m.hidden = false; else if (!hit) m.hidden = true; });
      openers.forEach(function (a) { a.setAttribute('aria-expanded', a.getAttribute('data-vx-mega-open') === key ? 'true' : 'false'); });
      current = key;
    }
    function hide() { megas.forEach(function (m) { m.hidden = true; }); openers.forEach(function (a) { a.setAttribute('aria-expanded', 'false'); }); current = null; }
    // Survol délégué (mouseover remonte) : plus fiable dans Safari que mouseenter posé lien par lien.
    var nav = qs('[data-vx-nav]', wrap);
    function hoverNav(e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-vx-mega-open],[data-vx-mega-close]') : null;
      if (!t || !nav.contains(t)) return;
      if (t.hasAttribute('data-vx-mega-open')) { if (current !== t.getAttribute('data-vx-mega-open')) show(t.getAttribute('data-vx-mega-open')); }
      else if (current) hide();
    }
    if (nav) { on(nav, 'mouseover', hoverNav); on(nav, 'pointerover', function (e) { if (e.pointerType === 'mouse') hoverNav(e); }); }
    openers.forEach(function (a) {
      on(a, 'focus', function () { if (current) show(a.getAttribute('data-vx-mega-open')); });
      on(a, 'keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); show(a.getAttribute('data-vx-mega-open')); var m = qs('[data-vx-mega="' + a.getAttribute('data-vx-mega-open') + '"] a', wrap); if (m) m.focus(); }
      });
    });
    qsa('[data-vx-mega-close]', wrap).forEach(function (a) { on(a, 'focus', hide); });
    on(wrap, 'mouseleave', function () { closeT = setTimeout(hide, 60); });
    on(wrap, 'mouseenter', function () { clearTimeout(closeT); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && current) { var o = qs('[data-vx-mega-open][aria-expanded="true"]', wrap); hide(); if (o) o.focus(); } });
    on(d, 'focusin', function (e) { if (current && !wrap.contains(e.target)) hide(); });
    on(window, 'resize', debounce(function () { if (!desktop()) hide(); }, 120));

    // Menu mobile (déplacé dans <body> pour échapper au contexte sticky de l'en-tête)
    var mnav = qs('[data-vx-mobile-nav]');
    var burger = qs('[data-vx-burger]');
    if (mnav) {
      d.body.appendChild(mnav);
      on(burger, 'click', function () { burger.setAttribute('aria-expanded', 'true'); openModal(mnav, { opener: burger, priority: 4, onClose: function () { burger.setAttribute('aria-expanded', 'false'); } }); });
      qsa('[data-vx-burger-close]', mnav).forEach(function (b) { on(b, 'click', function () { closeModal(mnav); }); });
      qsa('a', mnav).forEach(function (a) { on(a, 'click', function () { closeModal(mnav); }); });
      // Sous-menus en accordéon (un seul ouvert à la fois)
      var toggles = qsa('[data-vx-mnav-toggle]', mnav);
      toggles.forEach(function (b) {
        on(b, 'click', function () {
          var open = b.getAttribute('aria-expanded') !== 'true';
          toggles.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); var s = d.getElementById(o.getAttribute('aria-controls')); if (s) s.hidden = true; var p = qs('.vx-mnav__plus', o); if (p) p.textContent = '+'; });
          if (open) { b.setAttribute('aria-expanded', 'true'); var sub = d.getElementById(b.getAttribute('aria-controls')); if (sub) sub.hidden = false; var pl = qs('.vx-mnav__plus', b); if (pl) pl.textContent = '−'; }
        });
      });
    }
  }

  /* ---------- Recherche prédictive ---------- */
  function initSearch() {
    var modal = qs('[data-vx-search-modal]');
    if (!modal) return;
    var input = qs('[data-vx-search-input]', modal);
    var idle = qs('[data-vx-search-idle]', modal);
    var results = qs('[data-vx-search-results]', modal);
    var empty = qs('[data-vx-search-empty]', modal);
    var emptyTitle = qs('[data-vx-search-empty-title]', modal);
    var artists = [];
    try { artists = JSON.parse(qs('[data-vx-artists-json]', modal).textContent) || []; } catch (e) {}
    var artistUrls = {};
    artists.forEach(function (a) { artistUrls[a.url] = true; });
    var ctrl = null, lastQ = '';

    function open(e) { if (e) e.preventDefault(); openModal(modal, { opener: e && e.currentTarget, focus: '[data-vx-search-input]', priority: 3 }); }
    function close() { closeModal(modal); }
    qsa('[data-vx-search-open]').forEach(function (a) { on(a, 'click', open); });
    qsa('[data-vx-search-close]', modal).forEach(function (b) { on(b, 'click', close); });
    on(qs('[data-vx-search-clear]', modal), 'click', function () { input.value = ''; render(''); input.focus(); });

    function row(type, title, sub, url) {
      var a = d.createElement('a');
      a.className = 'vx-result'; a.href = url;
      a.innerHTML = '<span class="vx-result__type"></span><span class="vx-result__main"><span class="vx-result__title"></span><span class="vx-result__sub"></span></span>';
      a.children[0].textContent = type; qs('.vx-result__title', a).textContent = title; qs('.vx-result__sub', a).textContent = sub || '';
      return a;
    }
    function show(which) { idle.hidden = which !== 'idle'; results.hidden = which !== 'results'; empty.hidden = which !== 'empty'; }
    function render(q) {
      var nq = norm(q.trim());
      if (!nq) { show('idle'); return; }
      lastQ = q;
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var local = artists.filter(function (a) { return norm(a.name + ' ' + a.sub).indexOf(nq) > -1; }).slice(0, 4);
      var url = (R.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
        if (q !== lastQ) return;
        var res = (data && data.resources && data.resources.results) || {};
        var frag = d.createDocumentFragment(), n = 0, seen = {};
        local.forEach(function (a) { seen[a.url] = true; frag.appendChild(row(S.searchTypes.artist, a.name, S.artistPage, a.url)); n++; });
        (res.collections || []).forEach(function (c) {
          var u = c.url.split('?')[0]; if (seen[u]) return; seen[u] = true;
          var isArtist = artistUrls[u];
          frag.appendChild(row(isArtist ? S.searchTypes.artist : S.searchTypes.collection, c.title, isArtist ? S.artistPage : '', c.url)); n++;
        });
        (res.products || []).forEach(function (p) {
          var sub = [p.vendor, p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : ''].filter(Boolean).join(' · ');
          frag.appendChild(row(p.type || S.searchTypes.product, p.title, sub, p.url)); n++;
        });
        (res.articles || []).forEach(function (a) { frag.appendChild(row(S.searchTypes.article, a.title, a.author || '', a.url)); n++; });
        (res.pages || []).forEach(function (p) { frag.appendChild(row(S.searchTypes.page, p.title, '', p.url)); n++; });
        results.innerHTML = '';
        if (n) {
          results.appendChild(frag);
          var all = d.createElement('a'); all.className = 'vx-result vx-result--all';
          all.href = (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
          all.textContent = tpl(S.searchAll || 'Tous les résultats pour « __Q__ » →', { __Q__: q });
          results.appendChild(all);
          show('results');
        } else {
          emptyTitle.textContent = tpl(S.searchNoResults, { __Q__: q });
          show('empty');
        }
      }).catch(function () {});
    }
    on(input, 'input', debounce(function () { render(input.value); }, 180));
  }

  /* ---------- Carrousel d'accueil ---------- */
  function initHero() {
    qsa('[data-vx-hero]').forEach(function (hero) {
      var slides = qsa('[data-vx-slide]', hero);
      if (slides.length < 2) return;
      var dots = qsa('[data-vx-dot]', hero), count = qs('[data-vx-hero-count]', hero);
      var idx = 0, ms = parseInt(hero.getAttribute('data-interval'), 10) || 7000, timer;
      function go(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
        dots.forEach(function (b, k) { if (k === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
        var img = qs('img[loading="lazy"]', slides[idx]); if (img) img.loading = 'eager';
      }
      function start() { stop(); timer = setInterval(function () { if (!d.hidden) go(idx + 1); }, ms); }
      function stop() { clearInterval(timer); }
      dots.forEach(function (b, k) { on(b, 'click', function () { go(k); start(); }); });
      on(qs('[data-vx-hero-prev]', hero), 'click', function () { go(idx - 1); start(); });
      on(qs('[data-vx-hero-next]', hero), 'click', function () { go(idx + 1); start(); });
      on(hero, 'focusin', stop); on(hero, 'focusout', start);
      var sx = 0;
      on(hero, 'touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      on(hero, 'touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { go(idx + (dx < 0 ? 1 : -1)); start(); } }, { passive: true });
      start();
    });
  }

  /* ---------- Première visite : bandeau + infobulle ---------- */
  function initOnboarding() {
    var band = qs('[data-vx-onb-band]');
    if (band && !store('vx-onb-band')) {
      band.hidden = false;
      on(qs('[data-vx-onb-close]', band), 'click', function () { store('vx-onb-band', '1'); band.hidden = true; });
    }
    if (!store('vx-tip-edition')) {
      qsa('[data-vx-tip-edition]').forEach(function (tip) {
        tip.hidden = false;
        on(qs('[data-vx-tip-close]', tip), 'click', function () { store('vx-tip-edition', '1'); qsa('[data-vx-tip-edition]').forEach(function (t) { t.hidden = true; }); });
      });
    }
  }

  /* ---------- Galerie d'accueil : 1re pièce fixe, les autres mélangées ---------- */
  function shuffleArr(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  // Galerie de l'accueil : tirage aléatoire à chaque visite dans tout le réservoir (pièces visibles + réserve masquée)
  function initShuffle() {
    qsa('[data-vx-shuffle]').forEach(function (grid) {
      var limit = parseInt(grid.getAttribute('data-vx-shuffle-limit'), 10) || 0;
      var items = Array.prototype.slice.call(grid.children).map(function (el) {
        if (el.hasAttribute('data-vx-reserve')) { var tile = el.firstElementChild; grid.removeChild(el); return tile; }
        return el;
      }).filter(Boolean);
      if (items.length < 2) return;
      shuffleArr(items).forEach(function (el, i) {
        if (limit && i >= limit) { if (el.parentNode) el.parentNode.removeChild(el); return; }
        grid.appendChild(el);
        var img = i < 4 ? qs('img[loading="lazy"]', el) : null;
        if (img) img.loading = 'eager';
      });
    });
  }

  /* ---------- Favoris (localStorage vx-favs) ---------- */
  var Favs = {
    get: function () { try { return JSON.parse(store('vx-favs') || '[]') || []; } catch (e) { return []; } },
    set: function (list) { store('vx-favs', JSON.stringify(list)); Favs.sync(); },
    has: function (id) { return Favs.get().some(function (f) { return String(f.id) === String(id); }); },
    toggle: function (item) {
      var list = Favs.get(), i = list.findIndex(function (f) { return String(f.id) === String(item.id); });
      if (i > -1) list.splice(i, 1); else list.push(item);
      Favs.set(list);
    },
    sync: function () {
      var n = Favs.get().length;
      qsa('[data-vx-fav-count]').forEach(function (el) { el.textContent = n ? String(n) : ''; });
      qsa('[data-vx-fav-link]').forEach(function (a) { a.setAttribute('aria-label', n ? tpl(n > 1 ? S.favsCount : S.favsCountOne, { __N__: n }) : S.favs); });
      qsa('[data-vx-fav]').forEach(function (b) {
        var onF = Favs.has(b.getAttribute('data-id'));
        b.textContent = onF ? S.favOn : S.favAdd; b.setAttribute('aria-pressed', onF ? 'true' : 'false');
      });
    }
  };
  function initFavs() {
    on(d, 'click', function (e) {
      var b = e.target.closest && e.target.closest('[data-vx-fav]');
      if (!b) return;
      Favs.toggle({ id: b.getAttribute('data-id'), handle: b.getAttribute('data-handle'), artist: b.getAttribute('data-artist'), title: b.getAttribute('data-title'), price: b.getAttribute('data-price'), image: b.getAttribute('data-image'), adult: b.hasAttribute('data-adult') });
    });
    on(window, 'storage', function (e) { if (e.key === 'vx-favs') { Favs.sync(); renderFavPage(); } });
    Favs.sync();
    renderFavPage(true);
  }
  function renderFavPage(refresh) {
    var page = qs('[data-vx-favorites]');
    if (!page) return;
    var list = Favs.get(), grid = qs('[data-vx-fav-grid]', page), emptyEl = qs('[data-vx-fav-empty]', page), total = qs('[data-vx-fav-total]', page), t = qs('[data-vx-fav-template]', page);
    grid.innerHTML = '';
    emptyEl.hidden = list.length > 0; grid.hidden = !list.length; total.hidden = !list.length;
    total.textContent = tpl(list.length > 1 ? S.pieces : S.piecesOne, { __N__: list.length });
    list.forEach(function (f) {
      var node = t.content.firstElementChild.cloneNode(true);
      qs('[data-f-link]', node).href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + f.handle;
      var img = qs('[data-f-img]', node);
      if (f.image) { img.src = f.image; img.alt = (f.title || '') + ' - ' + (f.artist || ''); } else img.remove();
      if (f.adult && img.parentNode) { img.parentNode.classList.add('vx-adult'); var g = d.createElement('span'); g.className = 'vx-adult__gate'; g.innerHTML = '<span class="vx-adult__k"></span>'; g.firstChild.textContent = S.adultLabel || '18+'; img.parentNode.appendChild(g); }
      qs('[data-f-artist]', node).textContent = f.artist || '';
      qs('[data-f-title]', node).textContent = f.title || '';
      var pr = qs('[data-f-price]', node); pr.textContent = f.price || ''; pr.setAttribute('data-handle', f.handle);
      on(qs('[data-f-remove]', node), 'click', function () { Favs.toggle(f); renderFavPage(); });
      grid.appendChild(node);
    });
    if (refresh) {
      // Prix et disponibilité rafraîchis via /products/{handle}.js
      list.forEach(function (f) {
        fetch('/products/' + encodeURIComponent(f.handle) + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
          var price = (p.price_varies ? (S.from || 'Dès') + ' ' : '') + formatMoney(p.price);
          var all = Favs.get(); all.forEach(function (x) { if (String(x.id) === String(f.id)) { x.price = p.available ? price : S.soldOut; x.title = p.title; x.artist = p.vendor; } });
          store('vx-favs', JSON.stringify(all));
          var el = qs('[data-f-price][data-handle="' + f.handle + '"]', page);
          if (el) { el.textContent = p.available ? price : S.soldOut; el.classList.toggle('is-out', !p.available); }
        }).catch(function () {});
      });
    }
  }

  /* ---------- Panier Ajax (tiroir) ---------- */
  var Cart = {
    drawer: null,
    init: function () {
      Cart.drawer = qs('[data-vx-cart-drawer]');
      if (Cart.drawer) Cart.drawer.setAttribute('data-vx-animated-close', '');
      on(d, 'click', function (e) {
        var t = e.target.closest ? e.target : null; if (!t) return;
        var opener = t.closest('[data-vx-cart-open]');
        if (opener && Cart.drawer) { e.preventDefault(); Cart.open(opener); return; }
        if (t.closest('[data-vx-cart-close]')) { e.preventDefault(); Cart.close(); return; }
        var q = t.closest('[data-vx-qty-change]');
        if (q) { var line = q.closest('[data-vx-line]'); var cur = parseInt(qs('span', q.parentNode).textContent, 10) || 0; Cart.change(line, cur + parseInt(q.getAttribute('data-vx-qty-change'), 10)); return; }
        var up = t.closest('[data-vx-upsell]');
        if (up) { Cart.upsell(up); }
      });
      on(d, 'submit', function (e) {
        var f = e.target;
        if (f.matches && f.matches('[data-vx-product-form]')) { e.preventDefault(); Product.add(f); }
      });
      Cart.dynamicUpsell();
    },
    open: function (opener) {
      if (!Cart.drawer) { location.href = R.cart || '/cart'; return; }
      openModal(Cart.drawer, { opener: opener, priority: 1, focus: '.vx-icon-btn[data-vx-cart-close]' });
    },
    close: function () { closeModal(Cart.drawer, function () { var slot = qs('[data-vx-added-slot]', Cart.drawer); if (slot) slot.innerHTML = ''; }); },
    render: function (sections, added) {
      if (!sections || !sections['cart-drawer']) return Cart.refresh(added);
      var doc = parseHTML(sections['cart-drawer']);
      var inner = qs('[data-vx-cart-inner]', doc), cur = qs('[data-vx-cart-inner]', Cart.drawer);
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      var n = parseInt((qs('[data-vx-cart-count-drawer]', Cart.drawer) || {}).textContent, 10) || 0;
      Cart.count(n);
      if (added) Cart.showAdded(added);
      Cart.dynamicUpsell();
    },
    refresh: function (added) {
      return fetch((R.root || '/') + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) { Cart.render(s, added); });
    },
    count: function (n) {
      qsa('[data-vx-cart-count]').forEach(function (el) { el.textContent = pad2(n); });
      qsa('[data-vx-cart-btn]').forEach(function (b) { b.setAttribute('aria-label', n === 0 ? S.cartEmpty : n === 1 ? S.cartCountOne : tpl(S.cartCount, { __N__: n })); });
    },
    showAdded: function (label) {
      var slot = qs('[data-vx-added-slot]', Cart.drawer);
      if (!slot) return;
      slot.innerHTML = '<div class="vx-added" data-vx-added role="status"><div class="vx-kicker"></div><div></div><span class="vx-added__line" data-vx-added-line></span></div>';
      slot.firstChild.children[0].textContent = S.added;
      slot.firstChild.children[1].textContent = label;
    },
    error: function (msg) {
      var el = qs('[data-vx-cart-error]', Cart.drawer);
      if (el) { el.textContent = msg || S.error; el.hidden = false; }
    },
    change: function (line, qty) {
      if (!line) return;
      qty = Math.max(0, qty);
      line.classList.add('is-busy');
      var key = line.getAttribute('data-key'), vid = line.getAttribute('data-variant-id');
      var updates = {}; updates[key] = qty;
      // Retirer une œuvre retire aussi son encadrement lié (_pour)
      if (qty === 0) qsa('[data-vx-line][data-pour="' + vid + '"]', Cart.drawer).forEach(function (l) { updates[l.getAttribute('data-key')] = 0; });
      fetch((R.cartUpdate || '/cart/update') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: 'cart-drawer', sections_url: location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
        if (!res.ok) { line.classList.remove('is-busy'); Cart.error(res.j.description || res.j.message); return; }
        Cart.render(res.j.sections);
      }).catch(function () { line.classList.remove('is-busy'); Cart.error(); });
    },
    add: function (items, label, btn) {
      var body = { items: items, sections: 'cart-drawer', sections_url: location.pathname };
      return fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || S.error);
          Cart.render(res.j.sections, label);
          Cart.open(btn);
          return res.j;
        });
    },
    upsell: function (btn) {
      btn.disabled = true;
      if (btn.getAttribute('aria-pressed') === 'true') {
        var key = btn.getAttribute('data-line-key'), line = qs('[data-vx-line][data-key="' + key + '"]', Cart.drawer);
        if (line) Cart.change(line, 0);
        return;
      }
      Cart.add([{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }], null, null).catch(function (e) { btn.disabled = false; Cart.error(e.message); });
    },
    dynamicUpsell: function () {
      var box = Cart.drawer && qs('[data-vx-upsell-dynamic]', Cart.drawer);
      if (!box || box.getAttribute('data-done')) return;
      box.setAttribute('data-done', '1');
      var pid = box.getAttribute('data-product-id');
      fetch((R.recommendations || '/recommendations/products') + '.json?product_id=' + pid + '&limit=4&intent=complementary')
        .then(function (r) { return r.json(); }).then(function (j) {
          var inCart = qsa('[data-vx-line]', Cart.drawer).map(function (l) { return l.getAttribute('data-variant-id'); });
          var p = (j.products || []).filter(function (x) { return x.available && x.variants && inCart.indexOf(String(x.variants[0].id)) < 0; })[0];
          if (!p) return;
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          box.innerHTML = '<div class="vx-label"></div><div class="vx-upsell__row"><div></div><div><div class="vx-upsell__t"></div><div class="vx-upsell__s"></div></div><button type="button" class="vx-upsell__btn" data-vx-upsell aria-pressed="false"></button></div>';
          qs('.vx-label', box).textContent = S.upsellTitle || 'Souvent ajouté avec';
          if (p.featured_image) { var im = new Image(); im.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; im.alt = ''; im.loading = 'lazy'; qs('.vx-upsell__row > div', box).appendChild(im); }
          qs('.vx-upsell__t', box).textContent = p.title;
          qs('.vx-upsell__s', box).textContent = p.vendor || '';
          var b = qs('button', box); b.textContent = '+ ' + formatMoney(v.price); b.setAttribute('data-variant-id', v.id);
          box.hidden = false;
        }).catch(function () {});
    }
  };

  /* ---------- Fiches produit ---------- */
  var Product = {
    init: function () { qsa('[data-vx-product]').forEach(Product.setup); },
    setup: function (el) {
      var json; try { json = JSON.parse(qs('[data-vx-product-json]', el).textContent); } catch (e) { return; }
      el.__vx = { data: json, framed: false };
      var form = qs('[data-vx-product-form]', el);
      var fieldsets = qsa('[data-vx-option]', el);

      function selected() { return fieldsets.map(function (fs) { var b = qs('[data-vx-opt][aria-pressed="true"]', fs); return b ? b.getAttribute('data-value') : null; }); }
      function match(opts) { return json.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === null || opts[i] === o; }); })[0]; }

      function refreshAvailability(opts) {
        fieldsets.forEach(function (fs, i) {
          qsa('[data-vx-opt]', fs).forEach(function (b) {
            var test = opts.slice(); test[i] = b.getAttribute('data-value');
            var ok = json.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return test[k] === null || test[k] === o; }); });
            b.classList.toggle('is-out', !ok);
            if (fs.hasAttribute('data-vx-size-option')) b.disabled = !ok && b.getAttribute('aria-pressed') !== 'true';
          });
        });
      }

      function update(variant, opts) {
        if (!variant) {
          setBtn(false, S.unavailable); return;
        }
        el.__vx.variant = variant;
        var input = qs('[data-vx-variant-input]', el); if (input) input.value = variant.id;
        var price = qs('[data-vx-price]', el);
        if (price) price.innerHTML = '<span class="vx-price">' + formatMoney(variant.price) + (variant.compare > variant.price ? ' <s>' + formatMoney(variant.compare) + '</s>' : '') + '</span>';
        // Paiement en 3× : seulement dans la fourchette Klarna
        var ins = qs('[data-vx-instal]', el);
        if (ins) { var okI = variant.price >= +ins.getAttribute('data-min') && variant.price <= +ins.getAttribute('data-max'); ins.hidden = !okI; if (okI) ins.textContent = ins.getAttribute('data-tpl').replace('%A%', formatMoney(Math.ceil(variant.price / 3))); }
        // Encadré édition par variante
        qsa('[data-vx-edition-for]', el).forEach(function (box) { box.hidden = box.getAttribute('data-vx-edition-for') !== String(variant.id); });
        // Image de la variante
        if (variant.media) { var th = qs('[data-vx-thumb][data-media-id="' + variant.media + '"]', el); if (th) showThumb(th); }
        // Bouton
        if (json.lock === 'open') setBtn(variant.available, variant.available ? S.addToCart : S.soldOut);
        // URL
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u.toString()); }
        // Libellés d'options
        fieldsets.forEach(function (fs, i) { var lab = qs('[data-vx-option-value]', fs); if (lab) lab.textContent = opts[i] || ''; });
        // Encadrement : prix du cadre selon le format
        frameVariant();
        // Taille : guide + « épuisé · me prévenir »
        sizeState();
      }
      function setBtn(ok, label) {
        var b = qs('[data-vx-add-btn]', el); if (!b) return;
        b.disabled = !ok; b.textContent = label;
      }

      fieldsets.forEach(function (fs) {
        qsa('[data-vx-opt]', fs).forEach(function (b) {
          on(b, 'click', function () {
            qsa('[data-vx-opt]', fs).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); x.removeAttribute('data-vx-opt-on'); });
            b.setAttribute('aria-pressed', 'true');
            b.removeAttribute('data-vx-opt-on'); void b.offsetWidth; b.setAttribute('data-vx-opt-on', '');
            var opts = selected();
            var v = match(opts);
            if (!v || !v.available) {
              // Chercher une variante disponible qui garde ce choix
              var i = fieldsets.indexOf(fs), val = b.getAttribute('data-value');
              var alt = json.variants.filter(function (x) { return x.available && x.options[i] === val; })[0];
              if (alt && !v) {
                alt.options.forEach(function (o, k) { var fsk = fieldsets[k]; if (!fsk) return; qsa('[data-vx-opt]', fsk).forEach(function (x) { var on_ = x.getAttribute('data-value') === o; x.setAttribute('aria-pressed', on_ ? 'true' : 'false'); }); });
                opts = selected(); v = alt;
              }
            }
            refreshAvailability(opts);
            update(v, opts);
          });
        });
      });

      // Galerie : miniatures
      function showThumb(th) {
        qsa('[data-vx-thumb]', el).forEach(function (t) { t.removeAttribute('aria-current'); });
        th.setAttribute('aria-current', 'true');
        qsa('[data-vx-main-img]', el).forEach(function (img) {
          img.removeAttribute('srcset'); img.src = th.getAttribute('data-src'); img.setAttribute('srcset', th.getAttribute('data-srcset'));
          img.alt = th.getAttribute('data-alt');
        });
        var host = qs('[data-vx-main-media]', el); if (host) { if (host.__src) host.__src = th.getAttribute('data-hd'); else if (host.hasAttribute('data-vx-loupe-src')) host.setAttribute('data-vx-loupe-src', th.getAttribute('data-hd')); }
      }
      qsa('[data-vx-thumb]', el).forEach(function (th) { on(th, 'click', function () { showThumb(th); }); });

      // Agrandir
      on(qs('[data-vx-zoom]', el), 'click', function (e) {
        var cur = qs('[data-vx-thumb][aria-current="true"]', el);
        var src = cur ? cur.getAttribute('data-hd') : (qs('[data-vx-loupe]', el) || {}).getAttribute && qs('[data-vx-loupe]', el).getAttribute('data-vx-loupe-src');
        var img = qs('.vx-pgal__img', el);
        Lightbox.open(src || (img && (img.currentSrc || img.src)), img && img.alt, e.currentTarget);
      });
      qsa('[data-vx-zoom-src]', el).forEach(function (b) { on(b, 'click', function () { var im = qs('img', b); Lightbox.open(b.getAttribute('data-vx-zoom-src'), im && im.alt, b); }); });

      // Encadrement : baguettes magnétiques (longueur ≥ largeur de l'œuvre) ou cadre bois (même format)
      var frameBtns = qsa('[data-vx-frame-toggle]', el), gal = qs('[data-vx-gallery]', el);
      var frames = json.frames || {}, BAR_CM = 2;
      function nums(t) { var m = String(t || '').replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*[x×X]\s*(\d+(?:\.\d+)?)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; }
      function artDims(fmt, aspect) {
        var d = nums(fmt === undefined ? selected()[0] : fmt); if (!d) return null;
        var lo = Math.min(d[0], d[1]), hi = Math.max(d[0], d[1]);
        return (aspect || json.aspect || 0.75) > 1.02 ? { w: hi, h: lo } : { w: lo, h: hi };
      }
      function pick(mode, fmt, aspect) {
        var f = frames[mode], d = artDims(fmt, aspect);
        if (!f || !f.variants.length || !d) return null;
        var ok = f.variants.filter(function (v) { return v.available; });
        if (mode === 'bars') {
          var best = null;
          // Baguette = largeur exacte de l'œuvre + 1 cm (31 → 30 cm, 51 → 50 cm, 71 → 70 cm) ; sinon indisponible
          ok.forEach(function (v) { var m = String(v.title).match(/(\d+(?:[.,]\d+)?)/); var L = m ? parseFloat(m[1].replace(',', '.')) : 0; if (Math.abs(L - 1 - d.w) < 0.6) best = { v: v, L: L }; });
          return best ? best.v : null;
        }
        return ok.filter(function (v) { var n = nums(v.title); return n && Math.min(n[0], n[1]) === Math.min(d.w, d.h) && Math.max(n[0], n[1]) === Math.max(d.w, d.h); })[0] || null;
      }
      // Simulateur baguettes : épaisseur réelle 2 cm et dépassement (longueur − largeur) à l'échelle de l'œuvre
      // Tout est calculé sur la largeur affichée de l'œuvre : 1 cm réel = largeur affichée / largeur de l'œuvre (cm)
      function scaleBars() {
        var d = artDims(), fv = pick('bars'); if (!d) return;
        var m = fv && String(fv.title).match(/(\d+(?:[.,]\d+)?)/), L = m ? parseFloat(m[1].replace(',', '.')) : d.w;
        qsa('.vx-hang', el).forEach(function (h) {
          var img = qs('img', h), px = img && img.getBoundingClientRect().width;
          if (!px) return;
          var cm = px / d.w;
          h.style.setProperty('--vx-bar-h', Math.max(3, BAR_CM * cm).toFixed(2) + 'px');
          h.style.setProperty('--vx-bar-o', Math.max(0, (L - d.w) / 2 / d.w).toFixed(4));
        });
      }
      qsa('.vx-hang img', el).forEach(function (img) {
        on(img, 'load', scaleBars);
        if (window.ResizeObserver) new ResizeObserver(function () { scaleBars(); }).observe(img);
      });
      function frameVariant(mode) {
        mode = mode || el.__vx.frameMode;
        scaleBars();
        frameBtns.forEach(function (b) {
          var m = b.getAttribute('data-vx-frame-toggle'), fv = pick(m);
          b.disabled = !fv; b.classList.toggle('is-na', !fv);
          var p = qs('[data-vx-frame-price="' + m + '"]', el); if (p && fv) p.textContent = formatMoney(fv.price);
        });
        if (el.__vx.frameMode && !pick(el.__vx.frameMode)) setFrame(null);
        return mode ? pick(mode) : null;
      }
      function setFrame(mode) {
        el.__vx.frameMode = mode; el.__vx.framed = !!mode;
        frameBtns.forEach(function (b) {
          var on_ = b.getAttribute('data-vx-frame-toggle') === mode;
          b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
          b.removeAttribute('data-vx-opt-on'); if (on_) { void b.offsetWidth; b.setAttribute('data-vx-opt-on', ''); }
        });
        if (gal) { gal.classList.toggle('is-framed', !!mode); gal.setAttribute('data-frame', mode || ''); }
        if (mode === 'bars') scaleBars();
        var lh = qs('[data-vx-main-media]', el);
        if (lh) { if (mode && lh.hasAttribute('data-vx-loupe')) { lh.__src = lh.getAttribute('data-vx-loupe-src'); lh.removeAttribute('data-vx-loupe'); } else if (!mode && lh.__src) { lh.setAttribute('data-vx-loupe', ''); lh.setAttribute('data-vx-loupe-src', lh.__src); lh.__src = null; } }
        if (mode && gal && window.innerWidth <= 860) gal.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      }
      el.__vx.frameVariant = function () { return el.__vx.frameMode ? pick(el.__vx.frameMode) : null; };
      // Carte masquée si aucun format de l'œuvre ne correspond à cette option (ex. Fine Art A0/A1/A2)
      frameBtns.forEach(function (b) {
        var m = b.getAttribute('data-vx-frame-toggle');
        var fits = (json.variants || []).some(function (v) { return !!pick(m, v.options[0]); });
        if (!fits) b.hidden = true;
      });
      frameBtns.forEach(function (b) {
        on(b, 'click', function () { var m = b.getAttribute('data-vx-frame-toggle'); setFrame(el.__vx.frameMode === m ? null : m); });
      });
      // Lot : encadrement œuvre par œuvre (format et orientation de chaque œuvre)
      el.__vx.bundle = qsa('[data-vx-bundle-row]', el).map(function (row) {
        var fmt = row.getAttribute('data-fmt'), asp = parseFloat(row.getAttribute('data-aspect')) || 0.75;
        var sel = { title: row.getAttribute('data-title'), mode: '', fv: {} };
        var btns = qsa('[data-vx-bframe]', row);
        btns.forEach(function (b) {
          var m = b.getAttribute('data-vx-bframe');
          if (m) {
            var fv = pick(m, fmt, asp); sel.fv[m] = fv;
            if (!fv) { b.disabled = true; b.classList.add('is-out'); }
            else { var p = qs('[data-vx-bframe-price]', b); if (p) p.textContent = '+ ' + formatMoney(fv.price); }
          }
          on(b, 'click', function () {
            if (b.disabled) return;
            sel.mode = m;
            btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          });
        });
        return sel;
      });

      // Textile : guide des tailles, me prévenir
      var sgBtn = qs('[data-vx-sizeguide-toggle]', el), sg = qs('[data-vx-sizeguide]', el);
      function toggleSG(force) {
        if (!sg) return; var open = force !== undefined ? force : sg.hidden;
        sg.hidden = !open; sgBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      on(sgBtn, 'click', function () { toggleSG(); });
      on(qs('[data-vx-sizeguide-open]', el), 'click', function () { toggleSG(true); sgBtn.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' }); });
      var notifyForm = qs('[data-vx-notify-form]', el.parentNode) || qs('[data-vx-notify-form]');
      on(qs('[data-vx-notify-toggle]', el), 'click', function () {
        if (!notifyForm) return; notifyForm.classList.toggle('is-open');
        if (notifyForm.classList.contains('is-open')) { var i = qs('input[type="email"]', notifyForm); if (i) i.focus(); }
      });
      function sizeState() {
        var si = json.sizeIndex; if (si === undefined || si < 0) return;
        var opts = selected(), size = opts[si];
        if (sg) qsa('[data-size]', sg).forEach(function (r) { var hit = r.getAttribute('data-size') === size; qsa('span', r).forEach(function (c) { c.classList.toggle('is-on', hit); }); });
        var outs = qsa('[data-vx-size-option] [data-vx-opt].is-out', el).map(function (b) { return b.getAttribute('data-value'); });
        var tog = qs('[data-vx-notify-toggle]', el), lab = qs('[data-vx-out-size]', el);
        if (tog) { tog.hidden = !outs.length; if (lab && outs.length) lab.textContent = outs[0]; }
        var tags = notifyForm && qs('[data-vx-notify-tags]', notifyForm);
        if (tags && outs.length) tags.value = tags.getAttribute('data-base') + ',retour-' + norm(json.handle + '-' + outs[0]).replace(/[^a-z0-9-]/g, '-');
      }

      // Verrou drop : recharge à l'heure d'ouverture (si dans les 24 h)
      if (json.lock !== 'open' && json.unlockAt) {
        var wait = json.unlockAt - Date.now();
        if (wait > 0 && wait < 86400000) setTimeout(function () { location.reload(); }, wait + 1500);
      }

      var initOpts = selected();
      refreshAvailability(initOpts);
      sizeState();
      frameVariant();
    },
    add: function (form) {
      var el = form.closest('[data-vx-product]');
      var st = el && el.__vx;
      var btn = qs('[data-vx-add-btn]', form);
      var err = qs('[data-vx-form-error]', form);
      var vid = Number(qs('[data-vx-variant-input]', form).value);
      if (!vid || (btn && btn.disabled)) return;
      var items = [{ id: vid, quantity: 1 }];
      var label = st ? st.data.title : '';
      var v = st && st.data.variants.filter(function (x) { return x.id === vid; })[0];
      if (v && v.title && v.title !== 'Default Title') label += ' · ' + v.title.replace(/ \/ /g, ' · ');
      if (st && st.framed && st.frameVariant) {
        var fv = st.frameVariant();
        var ft = st.data.frames && st.data.frames[st.frameMode];
        if (fv) { items.push({ id: fv.id, quantity: 1, properties: { _pour: String(vid) } }); label += ' · ' + ((ft && ft.title) || '') + ' ' + fv.title; }
      }
      if (st && st.bundle && st.bundle.length) {
        var bx = qs('[data-vx-bundle]', el), propName = (bx && bx.getAttribute('data-vx-bundle-prop')) || 'Pour l\u2019œuvre', nb = 0;
        st.bundle.forEach(function (b) {
          var bfv = b.mode && b.fv[b.mode]; if (!bfv) return;
          var props = { _pour: String(vid) }; props[propName] = b.title;
          items.push({ id: bfv.id, quantity: 1, properties: props }); nb++;
        });
        if (nb) label += ' · + ' + nb + ' ' + (S.framesAdded || 'encadrement(s)');
      }
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      Cart.add(items, label, btn).catch(function (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
      }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }
  };

  /* ---------- Visionneuse « Agrandir » ---------- */
  var Lightbox = {
    el: null,
    init: function () {
      Lightbox.el = qs('[data-vx-lightbox]');
      if (!Lightbox.el) return;
      qsa('[data-vx-lightbox-close]', Lightbox.el).forEach(function (b) { on(b, 'click', function () { closeModal(Lightbox.el); }); });
    },
    open: function (src, alt, opener) {
      if (!Lightbox.el || !src) return;
      var img = qs('[data-vx-lightbox-img]', Lightbox.el);
      img.src = src; img.alt = alt || '';
      openModal(Lightbox.el, { opener: opener, priority: 5, focus: '[data-vx-lightbox-close].vx-icon-btn' });
    }
  };

  /* ---------- Produits liés (recommandations Shopify en repli) ---------- */
  // Ligne défilante : flèches précédent / suivant (défilement d'environ une largeur visible)
  // Mobile : accordéons de fiche fermés, textes longs repliés avec « Lire la suite »
  var mobileQ = window.matchMedia ? matchMedia('(max-width: 860px)') : { matches: false };
  function clampText(el) {
    if (el.__vxClamp || !mobileQ.matches) return;
    if (!el.offsetParent) return; // invisible (accordéon fermé) : on attendra l'ouverture
    el.__vxClamp = true;
    el.classList.add('vx-clamp', 'is-clamped');
    if (el.scrollHeight <= el.clientHeight + 40) { el.classList.remove('is-clamped'); return; }
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'vx-clamp-btn'; b.textContent = S.readMore || 'Lire la suite';
    b.setAttribute('aria-expanded', 'false');
    el.parentNode.insertBefore(b, el.nextSibling);
    on(b, 'click', function () {
      var open = el.classList.toggle('is-clamped') === false;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? (S.readLess || 'Réduire') : (S.readMore || 'Lire la suite');
    });
  }
  function initMobileText() {
    if (!mobileQ.matches) return;
    qsa('.vx-acc details[open]').forEach(function (dt) { dt.open = false; });
    qsa('.vx-acc details').forEach(function (dt) { on(dt, 'toggle', function () { if (dt.open) qsa('.vx-acc__body', dt).forEach(clampText); }); });
    qsa('.vx-head__text, [data-vx-clamp]').forEach(clampText);
  }

  // Lien « Préférences cookies » : rouvre le bandeau de consentement de Shopify (affiché seulement s'il est disponible)
  function initCookiePrefs() {
    qsa('[data-vx-cookie-prefs]').forEach(function (b) {
      function ready() { return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'; }
      function show() { if (ready()) b.hidden = false; }
      show(); if (b.hidden) { var n = 0, t = setInterval(function () { show(); if (!b.hidden || ++n > 20) clearInterval(t); }, 500); }
      on(b, 'click', function () { if (ready()) window.privacyBanner.showPreferences(); });
    });
  }

  function initRail() {
    qsa('[data-vx-rail]').forEach(function (rail) {
      var track = qs('[data-vx-rail-track]', rail), prev = qs('[data-vx-rail-prev]', rail), next = qs('[data-vx-rail-next]', rail);
      if (!track || rail.__vxRail) return; rail.__vxRail = true;
      function state() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduce.matches ? 'auto' : 'smooth' }); }
      on(prev, 'click', function () { go(-1); });
      on(next, 'click', function () { go(1); });
      on(track, 'scroll', debounce(state, 60), { passive: true });
      on(window, 'resize', debounce(state, 120));
      state();
    });
  }

  function initRelated() {
    qsa('[data-vx-related]:not([data-filled])').forEach(function (sec) {
      var url = sec.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var g = qs('[data-vx-related-grid]', parseHTML(html));
        if (g && g.children.length) { qs('[data-vx-related-grid]', sec).innerHTML = g.innerHTML; sec.hidden = false; }
      }).catch(function () {});
    });
  }

  /* ---------- Collections : filtres, tri, défilement infini ---------- */
  function initCollection() {
    var box = qs('[data-vx-collection]');
    if (box) {
      var sid = box.getAttribute('data-section-id');
      var swap = function (url) {
        box.setAttribute('aria-busy', 'true');
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid).then(function (r) { return r.text(); }).then(function (html) {
          var doc = parseHTML(html), nb = qs('[data-vx-collection]', doc);
          if (nb) { box.innerHTML = nb.innerHTML; history.replaceState(null, '', url); bindCollection(); initInfinite(); }
          box.removeAttribute('aria-busy');
        }).catch(function () { location.href = url; });
      };
      var bindCollection = function () {
        var form = qs('[data-vx-filter-form]', box);
        if (!form) return;
        var submit = function () {
          var fd = new FormData(form), p = new URLSearchParams();
          fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
          var sort = qs('[data-vx-sort]', box); if (sort) p.set('sort_by', sort.value);
          swap(location.pathname + '?' + p.toString());
        };
        on(form, 'submit', function (e) { e.preventDefault(); submit(); });
        qsa('input[type="checkbox"]', form).forEach(function (c) { on(c, 'change', submit); });
        on(qs('[data-vx-sort]', box), 'change', submit);
        qsa('.vx-active-filters a, .vx-filter__actions a', box).forEach(function (a) { on(a, 'click', function (e) { e.preventDefault(); swap(a.getAttribute('href')); }); });
        qsa('[data-vx-filter]', box).forEach(function (det) {
          on(det, 'toggle', function () { if (det.open) qsa('[data-vx-filter]', box).forEach(function (o) { if (o !== det) o.open = false; }); });
        });
      };
      on(d, 'click', function (e) { if (!e.target.closest('[data-vx-filter]')) qsa('[data-vx-filter][open]', box).forEach(function (o) { o.open = false; }); });
      bindCollection();
    }
    initInfinite();
  }
  var infObs = null;
  function initInfinite() {
    qsa('[data-vx-infinite]').forEach(function (sentinel) {
      if (sentinel.__bound) return; sentinel.__bound = true;
      var grid = sentinel.parentNode.querySelector('[data-vx-grid]');
      var text = qs('[data-vx-listend-text]', sentinel.parentNode);
      var loading = false;
      var load = function () {
        var next = sentinel.getAttribute('data-next-url');
        if (!next || loading || !grid) return;
        loading = true;
        var sec = sentinel.closest('.shopify-section');
        var sid = sec ? sec.id.replace('shopify-section-', '') : '';
        fetch(next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid).then(function (r) { return r.text(); }).then(function (html) {
          var doc = parseHTML(html);
          var g = qs('[data-vx-grid]', doc), s2 = qs('[data-vx-infinite]', doc);
          if (g) Array.prototype.slice.call(g.children).forEach(function (c) { grid.appendChild(c); });
          var nextUrl = s2 ? s2.getAttribute('data-next-url') : '';
          sentinel.setAttribute('data-next-url', nextUrl || '');
          var shown = grid.children.length, total = parseInt(sentinel.getAttribute('data-total'), 10) || shown;
          if (text) text.textContent = nextUrl ? tpl(S.collMore, { __SHOWN__: shown, __TOTAL__: total }) : tpl(S.collEnd, { __N__: total });
          loading = false;
          applyCatalogueFilter();
          if (nextUrl) check();
        }).catch(function () { loading = false; });
      };
      var check = function () {
        if (!d.body.contains(sentinel)) return;
        var r = sentinel.getBoundingClientRect();
        if (r.top - window.innerHeight < 900) load();
      };
      on(window, 'scroll', debounce(check, 60), { passive: true });
      check();
    });
  }

  /* ---------- Page artiste : fonds tournants, filtres du catalogue, alerte ---------- */
  var catFilter = '';
  function applyCatalogueFilter() {
    var cat = qs('[data-vx-catalogue]'); if (!cat) return;
    // Comparaison sans ponctuation : « impression-dart » et « impression-d-art » concordent
    var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
    // « universe » et « jewel » filtrent sur un attribut de la carte, les autres clés sur le type
    var flags = { universe: 'data-universe', jewel: 'data-jewel' };
    var keys = catFilter ? catFilter.split(',').map(function (k) { return flags[k] ? k : norm(k); }) : [];
    var n = 0;
    qsa('[data-vx-grid] > *', cat).forEach(function (tile) {
      var type = norm(tile.getAttribute('data-product-type'));
      var show = !keys.length || keys.some(function (k) { return flags[k] ? tile.hasAttribute(flags[k]) : type === k; });
      tile.hidden = !show; if (show) n++;
    });
    // Tant qu'il reste des pages à charger, pas de message « vide » : le chargement continue
    var more = qs('[data-vx-infinite]', cat), hasMore = !!(more && more.getAttribute('data-next-url'));
    var em = qs('[data-vx-cat-empty]', cat); if (em) em.hidden = n > 0 || hasMore;
  }
  function initArtist() {
    // Bio longue : repliée à ~9 lignes, bouton « Lire la suite »
    qsa('[data-vx-bio]').forEach(function (bio) {
      var btn = bio.parentNode.querySelector('[data-vx-bio-toggle]');
      if (!btn || bio.hasAttribute('data-vx-bio-ready')) return;
      bio.setAttribute('data-vx-bio-ready', '');
      bio.classList.add('is-clamped');
      if (bio.scrollHeight <= bio.clientHeight + 24) { bio.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      on(btn, 'click', function () {
        var open = bio.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
    var bg = qs('[data-vx-artist-bg]');
    if (bg) {
      var imgs = qsa('.vx-artist__bgimg', bg), i = 0;
      imgs.forEach(function (x) { var im = qs('img', x); if (im) im.loading = 'eager'; });
      if (imgs.length > 1 && !reduce.matches) setInterval(function () { if (d.hidden) return; imgs[i].classList.remove('is-active'); i = (i + 1) % imgs.length; imgs[i].classList.add('is-active'); }, 5000);
    }
    qsa('[data-vx-cat-filter]').forEach(function (b) {
      on(b, 'click', function () {
        qsa('[data-vx-cat-filter]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
        catFilter = b.getAttribute('data-vx-cat-filter'); applyCatalogueFilter();
        // La grille filtrée peut devenir courte : relance le chargement des pages suivantes
        window.dispatchEvent(new Event('scroll'));
      });
    });
    var alertBtn = qs('[data-vx-alert-toggle]'), alertForm = qs('[data-vx-alert-form]');
    if (alertForm && !postedFor('VxAlert')) alertForm.hidden = true;
    if (alertForm && postedFor('VxAlert')) alertForm.hidden = true;
    on(alertBtn, 'click', function () {
      if (!alertForm) return;
      alertForm.hidden = !alertForm.hidden; alertBtn.setAttribute('aria-expanded', alertForm.hidden ? 'false' : 'true');
      if (!alertForm.hidden) qs('input[type="email"]', alertForm).focus();
    });
  }

  /* ---------- Artistes (index) : filtre par discipline ---------- */
  function initArtistsIndex() {
    var list = qs('[data-vx-alist]'); if (!list) return;
    var chips = qsa('[data-vx-discipline]');
    function apply(key) {
      chips.forEach(function (c) { var on_ = c.getAttribute('data-vx-discipline') === key; c.classList.toggle('is-active', on_); c.setAttribute('aria-pressed', on_ ? 'true' : 'false'); });
      qsa('[data-disciplines]', list).forEach(function (a) { a.hidden = !!key && (a.getAttribute('data-disciplines') || '').split('|').indexOf(key) < 0; });
    }
    chips.forEach(function (c) { on(c, 'click', function () { var k = c.getAttribute('data-vx-discipline'); apply(k); if (history.replaceState) history.replaceState(null, '', k ? '#' + (c.getAttribute('data-vx-anchor') || k) : location.pathname); }); });
    /* L'ancre du menu est stable d'une langue à l'autre (#tatouage) ; la clé de la puce suit la langue (tattoo). */
    function fromHash() {
      var h = decodeURIComponent(location.hash.replace('#', ''));
      if (!h) return;
      var hit = chips.filter(function (c) { return c.getAttribute('data-vx-anchor') === h || c.getAttribute('data-vx-discipline') === h; })[0];
      if (hit) apply(hit.getAttribute('data-vx-discipline'));
    }
    fromHash();
    on(window, 'hashchange', fromHash);
  }

  /* ---------- Galerie découverte : placement (porté de discLayout) ---------- */
  function initDiscover() {
    var wrap = qs('[data-vx-discover]');
    if (!wrap) return;
    var grid = qs('[data-vx-disc-grid]', wrap), end = qs('[data-vx-disc-end]', wrap), endText = qs('[data-vx-disc-end-text]', wrap);
    var total = parseInt(wrap.getAttribute('data-total'), 10) || 0;
    var base = wrap.getAttribute('data-tiles-url');
    var nextPage = parseInt(wrap.getAttribute('data-next-page'), 10) || 26, hasNext = wrap.getAttribute('data-has-next') === 'true', loading = false;
    var U = 4, G = 12;
    // Ordre aléatoire à chaque visite : tout le catalogue rendu est mélangé, 48 pièces affichées, le reste en réserve (hors DOM, images non chargées)
    var first = parseInt(wrap.getAttribute('data-first'), 10) || 48, batch = parseInt(wrap.getAttribute('data-batch'), 10) || 36;
    var reserve = shuffleArr(Array.prototype.slice.call(grid.children).filter(function (t) { return t.nodeType === 1; }));
    reserve.forEach(function (t) { grid.removeChild(t); });
    reserve.splice(0, first).forEach(function (t) { grid.appendChild(t); });

    function seed(tile) {
      if (tile.__rnd !== undefined) return;
      tile.__rnd = Math.random();
      tile.__off = Math.random() < 0.25 ? 12 + Math.floor(Math.random() * 28) : 0;
    }
    function layout() {
      var tiles = Array.prototype.slice.call(grid.children).filter(function (t) { return t.nodeType === 1; });
      var W = grid.clientWidth;
      var cols = W >= 1100 ? 6 : W >= 700 ? 4 : 2;
      var colW = (W - G * (cols - 1)) / cols;
      var hs = []; for (var i = 0; i < cols; i++) hs.push(0);
      grid.style.gridTemplateColumns = 'repeat(' + cols + ',minmax(0,1fr))';
      tiles.forEach(function (tile) {
        seed(tile);
        var a = parseFloat(tile.getAttribute('data-aspect')) || 0.72;
        var opts = a > 1.6 ? [3, 4, 4, 6] : a > 1.05 ? [2, 3, 3, 4] : a > 0.9 ? [2, 2, 3] : [1, 2, 2, 2, 3];
        if (cols <= 2) opts = a > 1.05 ? [2] : [1];
        else if (cols <= 4) opts = opts.map(function (c) { return Math.min(c, a > 1.05 ? 4 : 2); });
        opts = opts.map(function (c) { return Math.min(c, cols); });
        var pref = opts[Math.floor(tile.__rnd * opts.length)];
        var cand = [pref].concat(opts).filter(function (v, k, arr) { return arr.indexOf(v) === k; });
        var best = null;
        cand.forEach(function (c) {
          var rows = Math.ceil(((colW * c + G * (c - 1)) / a + 2 + G) / U);
          for (var x = 0; x + c <= cols; x++) {
            var top = 0, waste = 0, k;
            for (k = x; k < x + c; k++) top = Math.max(top, hs[k]);
            for (k = x; k < x + c; k++) waste += top - hs[k];
            var score = top + waste * 1.2 + (c === pref ? 0 : 30) + tile.__rnd * 6;
            if (!best || score < best.score) best = { score: score, c: c, x: x, top: top, rows: rows, waste: waste };
          }
        });
        var off = best.waste === 0 && tile.__off ? Math.round(tile.__off / U) : 0;
        var r = best.rows + off;
        for (var k2 = best.x; k2 < best.x + best.c; k2++) hs[k2] = best.top + r;
        tile.style.gridColumn = (best.x + 1) + ' / span ' + best.c;
        tile.style.gridRow = (best.top + 1) + ' / span ' + r;
        tile.style.paddingTop = (off * U) + 'px';
      });
      grid.classList.add('is-laid');
    }
    function finish() {
      if (hasNext || reserve.length) return;
      end.hidden = false;
      if (endText) endText.textContent = tpl(S.discoverEnd, { __N__: grid.children.length });
    }
    function loadMore() {
      if (reserve.length) { reserve.splice(0, batch).forEach(function (t) { grid.appendChild(t); }); layout(); finish(); return; }
      if (loading || !hasNext) return;
      loading = true;
      var pages = [nextPage, nextPage + 1, nextPage + 2];
      Promise.all(pages.map(function (p) {
        return fetch(base + '&page=' + p).then(function (r) { return r.text(); }).catch(function () { return ''; });
      })).then(function (htmls) {
        var added = 0;
        htmls.forEach(function (h) {
          if (!h || !hasNext) return;
          var batch = qs('[data-vx-disc-batch]', parseHTML(h));
          if (!batch) { hasNext = false; return; }
          Array.prototype.slice.call(batch.children).forEach(function (t) { grid.appendChild(t); added++; });
          if (batch.getAttribute('data-has-next') !== 'true') hasNext = false;
        });
        nextPage += 3;
        if (!added && htmls.every(function (h) { return !h; })) hasNext = false;
        layout(); loading = false; finish();
      });
    }
    on(window, 'scroll', function () { if (d.documentElement.scrollHeight - window.scrollY - window.innerHeight < 900) loadMore(); }, { passive: true });
    var lastW = 0;
    on(window, 'resize', debounce(function () { if (grid.clientWidth !== lastW) { lastW = grid.clientWidth; layout(); } }, 120));
    on(qs('[data-vx-disc-shuffle]', wrap), 'click', function () {
      var tiles = Array.prototype.slice.call(grid.children);
      for (var i = tiles.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = tiles[i]; tiles[i] = tiles[j]; tiles[j] = t; }
      tiles.forEach(function (t) { t.__rnd = undefined; grid.appendChild(t); });
      layout();
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
    });
    lastW = grid.clientWidth; layout(); finish();
  }

  /* ---------- Pop-up Club Vortex ---------- */
  function initClub() {
    var modal = qs('[data-vx-club-modal]');
    var tab = qs('[data-vx-clubtab]');
    var toast = qs('[data-vx-toast][data-vx-posted-for="VxClubForm"]');
    var C = T.club || {};
    var DAY = 86400000;
    var joined = store('vx-club-joined') || C.member;
    var seen = parseInt(store('vx-club-seen') || '0', 10);
    var recent = seen && (Date.now() - seen) < (C.days || 30) * DAY;

    // Succès : toast + mémoire
    if (toast && !toast.hasAttribute('data-vx-never') && (postedFor('VxClubForm') || !location.hash)) {
      store('vx-club-joined', '1'); joined = true;
      toast.hidden = false;
      var tt = setTimeout(function () { toast.hidden = true; }, 7000);
      on(qs('[data-vx-toast-close]', toast), 'click', function () { clearTimeout(tt); toast.hidden = true; });
    }
    if (!modal) return;
    modal.setAttribute('data-vx-animated-close', '');
    var form = qs('[data-vx-club-form]', modal), email = qs('[data-vx-club-email]', modal), msg = qs('[data-vx-club-msg]', modal);

    function playLogo() {
      var slot = qs('[data-vx-club-logo-slot]', modal); if (!slot) return;
      var old = qs('[data-vx-club-logo]', modal); if (old) old.remove();
      var s = d.createElement('span');
      s.className = 'vx-popup__logo'; s.setAttribute('data-vx-logo-anim', ''); s.setAttribute('data-vx-club-logo', ''); s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<span class="vx-logo-fallback" data-vx-logo-fallback></span>';
      slot.parentNode.insertBefore(s, slot);
    }
    function open(opener) {
      if (tab) tab.hidden = true;
      playLogo();
      openModal(modal, { opener: opener, priority: 2, onClose: function () { if (!joined && tab) tab.hidden = false; } });
      store('vx-club-seen', String(Date.now()));
    }
    function close() { closeModal(modal); }
    qsa('[data-vx-club-close]', modal).forEach(function (b) { on(b, 'click', close); });
    on(tab, 'click', function () { open(tab); });
    qsa('[data-vx-club-open]').forEach(function (a) { on(a, 'click', function (e) { e.preventDefault(); open(a); }); });  // sans pop-up, le lien mène à /pages/club

    // Validation (novalidate)
    function setError(t) {
      msg.textContent = t || ''; msg.hidden = !t;
      email.setAttribute('aria-invalid', t ? 'true' : 'false');
      form.classList.toggle('is-error', !!t);
    }
    on(email, 'input', function () { if (!msg.hidden) setError(''); });
    on(form, 'submit', function (e) {
      var v = (email.value || '').trim();
      if (!v) { e.preventDefault(); setError(S.emailEmpty); email.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { e.preventDefault(); setError(v.indexOf('@') > -1 ? S.emailIncomplete : S.emailNoAt); email.focus(); return; }
      store('vx-club-seen', String(Date.now()));
    });

    // Erreur renvoyée par Shopify : on rouvre la pop-up
    if (qs('[data-vx-club-has-error]') && location.hash === '#VxClubForm') { open(); return; }
    if (joined) return;
    if (C.enabled && recent && tab) tab.hidden = false;
    if (!C.enabled || recent || T.template !== 'index') return;
    // Seul un vrai défilement du visiteur compte (pas la position restaurée par le navigateur au rechargement)
    var engaged = false;
    ['wheel', 'touchmove', 'keydown', 'pointerdown'].forEach(function (ev) { on(window, ev, function () { engaged = true; }, { passive: true, once: true }); });
    var trig = function () {
      if (engaged && window.scrollY > (C.scroll || 1600) && !stack.length) { window.removeEventListener('scroll', trig); open(); }
    };
    on(window, 'scroll', trig, { passive: true });
  }

  /* ---------- Contenu adulte : un clic « Je suis majeur·e » défloute tout le site pour la visite ---------- */
  function initAdult() {
    var root = d.documentElement;
    function ok() { return root.classList.contains('vx-adult-ok'); }
    function reveal() { root.classList.add('vx-adult-ok'); try { sessionStorage.setItem('vx-adult-ok', '1'); } catch (e) {} }
    // Phase de capture : le premier clic sur une œuvre floutée défloute au lieu d'ouvrir le lien ou la loupe
    d.addEventListener('click', function (e) {
      if (ok()) return;
      var t = e.target.closest && e.target.closest('[data-vx-adult-ok], .vx-adult');
      if (!t) return;
      e.preventDefault(); e.stopPropagation();
      reveal();
    }, true);
  }

  /* ---------- Formulaires de page : motif du contact + validation avant envoi ---------- */
  function initPageForms() {
    qsa('form[data-vx-validate]').forEach(function (form) {
      var errs = qs('[data-vx-form-errs]', form); if (!errs) return;
      var reason = qs('[data-vx-reason]', form);
      var orderBox = qs('[data-vx-reason-order]', form), otherBox = qs('[data-vx-reason-other]', form);
      function syncReason() {
        if (!reason) return;
        var opt = reason.options[reason.selectedIndex];
        var needOrder = !!(opt && opt.hasAttribute('data-order')), needOther = !!(opt && opt.hasAttribute('data-other'));
        if (orderBox) { orderBox.hidden = !needOrder; qs('input', orderBox).required = needOrder; }
        if (otherBox) { otherBox.hidden = !needOther; qs('input', otherBox).required = needOther; }
      }
      function fieldOf(inp) { return inp.closest('.vx-field'); }
      function setErr(inp, msg) {
        var f = fieldOf(inp); if (!f) return;
        var p = qs('.vx-field__err', f);
        if (!msg) { inp.removeAttribute('aria-invalid'); if (p) p.remove(); return; }
        if (!p) { p = document.createElement('p'); p.className = 'vx-field__err'; p.id = inp.id + '-err'; f.appendChild(p); }
        p.textContent = msg;
        inp.setAttribute('aria-invalid', 'true');
        inp.setAttribute('aria-describedby', ((inp.getAttribute('aria-describedby') || '').replace(p.id, '') + ' ' + p.id).trim());
      }
      function check(inp) {
        var v = (inp.value || '').trim();
        if (inp.required && !v) return inp.name === 'contact[Commande]' ? errs.getAttribute('data-order') : errs.getAttribute('data-required');
        if (inp.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return errs.getAttribute('data-email');
        return '';
      }
      if (reason) { on(reason, 'change', function () { syncReason(); setErr(reason, ''); }); syncReason(); }
      qsa('.vx-input', form).forEach(function (inp) {
        on(inp, 'input', function () { if (inp.getAttribute('aria-invalid')) setErr(inp, check(inp)); });
      });
      on(form, 'submit', function (e) {
        var first = null;
        qsa('.vx-input', form).forEach(function (inp) {
          var box = fieldOf(inp); if (box && box.hidden) { setErr(inp, ''); return; }
          var m = check(inp); setErr(inp, m);
          if (m && !first) first = inp;
        });
        if (first) {
          e.preventDefault();
          first.scrollIntoView({ block: 'center' });
          try { first.focus({ preventScroll: true }); } catch (x) { first.focus(); }
        }
      });
    });
  }

  /* ---------- Formulaires : après envoi, amener la confirmation (ou les erreurs) à l'écran ---------- */
  function initFormFeedback() {
    var fb = qs('[data-vx-form-feedback]'); if (!fb) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(function () {
      fb.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      try { fb.focus({ preventScroll: true }); } catch (e) {}
    });
  }

  /* ---------- Page devis : pré-remplissage de l'œuvre ---------- */
  function initQuote() {
    var f = qs('[data-vx-prefill-oeuvre]'); if (!f) return;
    try {
      var p = new URLSearchParams(location.search).get('oeuvre');
      if (p && !f.value) f.value = p;
      // Contact : le champ « Œuvre » n'apparaît que si l'on arrive depuis une fiche (devis de livraison)
      var box = f.closest('[data-vx-oeuvre-field]'); if (box && p) box.hidden = false;
      var q = p && qs('[data-vx-reason-quote]');
      if (q) { q.selected = true; q.parentNode.dispatchEvent(new Event('change')); }
    } catch (e) {}
  }

  /* ---------- Démarrage ---------- */
  /* ---------- Protection des œuvres : clic droit / glisser bloqués sur les images ---------- */
  function initProtect() {
    if (!d.documentElement.classList.contains('vx-protect')) return;
    var SEL = '.vx-art, [data-vx-loupe], .vx-lightbox, .vx-hero__media, .vx-artist__bgimg, .vx-artist__feature';
    function guard(e) { var t = e.target; if (t && t.closest && t.closest(SEL) && (t.tagName === 'IMG' || t.closest('[data-vx-loupe]'))) e.preventDefault(); }
    on(d, 'contextmenu', guard);
    on(d, 'dragstart', guard);
  }

  function boot() {
    initPosted();
    initHeader();
    initSearch();
    Cart.init();
    Lightbox.init();
    initHero();
    initOnboarding();
    initShuffle();
    initFavs();
    Product.init();
    initRelated();
    initRail();
    initCookiePrefs();
    initMobileText();
    initCollection();
    initArtist();
    initArtistsIndex();
    initDiscover();
    initClub();
    initQuote();
    initFormFeedback();
    initPageForms();
    initAdult();
    initProtect();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  // Éditeur de thème : réinitialisation des sections rechargées
  on(d, 'shopify:section:load', function () { initHero(); initOnboarding(); Product.init(); initDiscover(); initArtist(); initInfinite(); });

  window.VX = { cart: Cart, favs: Favs, formatMoney: formatMoney, openModal: openModal, closeModal: closeModal };
})();
